import React from 'react';
import { Link } from 'react-router-dom';

export default function Register() {
  return (
    <div className="container" style={{ maxWidth: 480, margin: '48px auto', padding: '0 16px' }}>
      <div className="card" style={{ padding: 28 }}>
        <h1 style={{ marginTop: 0 }}>Register</h1>
        <p>PocketGuru is <strong>invite only</strong> for now.</p>
        <p style={{ color: '#555', lineHeight: 1.6 }}>
          Ask someone who already uses PocketGuru for an invite code. Public self-serve signup
          (invite codes, Telegram link, SMS API key) is planned — not live yet.
        </p>
        <p style={{ marginBottom: 0 }}>
          Already have access? <Link to="/login">Log in</Link>
          {' · '}
          <Link to="/">Back to home</Link>
        </p>
      </div>
    </div>
  );
}
